import {
    Button,
    Grid,
    IconButton,
    Slide,
    SlideProps,
    Snackbar,
    Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Alert } from "@mui/material";
import type {
    MessageOptions,
    Severity,
} from "components/ManagerInteractions/Stores/MessageStore";
import React, { FunctionComponent } from "react";

interface Props {
    open?: boolean;
    message: string;
    autoHideDuration?: number;
    onClose: () => void;
    actions?: React.ReactNode;
    severity?: Severity;
    options?: MessageOptions;
}

function SlideTransition(props: SlideProps) {
    return <Slide {...props} timeout={500} direction="down" />;
}

const AcxSnackBar: FunctionComponent<
    React.PropsWithChildren<React.PropsWithChildren<Props>>
> = (props) => {
    let severity = props.severity;
    if (!severity) {
        severity = "info";
    }
    return (
        <Snackbar
            style={{ zIndex: 99999999999 }}
            anchorOrigin={{
                vertical: "top",
                horizontal: "center",
            }}
            open={Boolean(props.open)}
            autoHideDuration={props.autoHideDuration ?? 1 * 60 * 1000} // 1 Minute
            onClose={props.onClose}
            TransitionComponent={SlideTransition}
        >
            <Alert
                severity={severity}
                action={
                    <React.Fragment>
                        {Boolean(props.actions) && props.actions}
                        <IconButton
                            size="small"
                            aria-label="close"
                            color="inherit"
                            onClick={props.onClose}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </React.Fragment>
                }
            >
                <Typography
                    style={{
                        paddingLeft: "8px",
                        color: "inherit",
                        whiteSpace: "pre-line",
                    }}
                    variant="body1"
                >
                    {props.message}
                </Typography>

                {props.options && (
                    <Grid
                        container
                        item
                        xs={12}
                        alignContent="center"
                        alignItems="center"
                    >
                        {!props.options?.hideButton?.approve && (
                            <Button
                                style={{
                                    textTransform: "none",
                                }}
                                variant="text"
                                color="secondary"
                                onClick={props.options?.buttonAction.approve}
                            >
                                {props.options?.buttonText.approve}
                            </Button>
                        )}
                        {!props.options?.hideButton?.deny && (
                            <Button
                                style={{
                                    textTransform: "none",
                                }}
                                variant="text"
                                color="secondary"
                                onClick={props.options?.buttonAction.deny}
                            >
                                {props.options?.buttonText.deny}
                            </Button>
                        )}
                    </Grid>
                )}
            </Alert>
        </Snackbar>
    );
};

export default AcxSnackBar;
